"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactTracking = require("react-tracking");

var _stitches = require("../../../stitches.config");

var TipContainer = (0, _stitches.styled)('div', {
  fontSize: '$small',
  position: 'relative',
  // unset sfcc styles
  button: {
    backgroundColor: '$greenLightest',
    border: 0,
    borderRadius: '6px',
    color: '$textPrimary',
    display: 'flex',
    padding: '5px',
    paddingRight: '10px',
    '&:hover:not([disabled])': {
      backgroundColor: '$greenLightest',
      color: '$textPrimary'
    }
  }
});
var TipButton = (0, _stitches.styled)('div', {
  alignItems: 'center',
  textAlign: 'center',
  borderRadius: '6px',
  backgroundColor: '$greenLightest',
  // if you don't explicitly set color on buttons on ios, it changes them to blue on safari. incredible.
  color: '$textPrimary',
  display: 'flex',
  fontFamily: '$asics',
  fontSize: '15px',
  fontWeight: '$bold',
  fontStretch: '100%',
  minWidth: '72.5px',
  padding: '5px',
  letterSpacing: '0.4px',
  lineHeight: 'normal',
  '&:hover': {
    cursor: 'pointer'
  },
  img: {
    height: '20px',
    marginRight: '5px'
  }
}); // TODO: what about making this whole thing clickable instead of just the x?

var TipDescription = (0, _stitches.styled)('div', {
  backgroundColor: '$greenLightest',
  borderRadius: '5px',
  fontWeight: '$medium',
  paddingBottom: '10px',
  paddingLeft: '10px',
  paddingRight: '15px',
  paddingTop: '10px',
  position: 'absolute',
  right: 0,
  top: 0,
  width: '200px',
  display: 'none',
  variants: {
    visibility: {
      true: {
        display: 'block'
      },
      false: {
        display: 'hidden'
      }
    }
  }
});
var CloseButtonContainer = (0, _stitches.styled)('div', {
  fontWeight: '$semiBold',
  position: 'absolute',
  right: '5px',
  top: '4px',
  '&:hover': {
    cursor: 'pointer'
  }
});
/**
 * A button that can be triggered to display helpful information for a user.
 */

var Tip = function Tip(_ref) {
  var buttonText = _ref.buttonText,
      description = _ref.description,
      icon = _ref.icon;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showDescription = _useState2[0],
      setShowDescription = _useState2[1];

  var dialogOpenTrigger = (0, _react.useRef)(null);
  var dialogDescriptionTrigger = (0, _react.useRef)(null);
  var dialogCloseTrigger = (0, _react.useRef)(null);

  var _useTracking = (0, _reactTracking.useTracking)(),
      trackEvent = _useTracking.trackEvent;

  var toggleShowDescription = function toggleShowDescription() {
    setShowDescription(!showDescription);

    if (showDescription) {
      dialogOpenTrigger.current.focus();
    } else {
      dialogOpenTrigger.current.blur();
      dialogDescriptionTrigger.current.focus();
    }

    trackEvent({
      gaEventAction: 'click',
      gaEventLabel: "".concat(buttonText, " click").toLowerCase(),
      gaEventNonInteraction: false
    });
  };

  (0, _react.useEffect)(function () {
    var handleKeyboardEvent = function handleKeyboardEvent(event) {
      if (event && (document.activeElement === dialogOpenTrigger.current || document.activeElement === dialogDescriptionTrigger.current || document.activeElement === dialogCloseTrigger.current)) {
        if (event.key === 'Escape' && showDescription || event.key === 'Enter') {
          toggleShowDescription();
        }
      }
    };

    document.addEventListener('keydown', handleKeyboardEvent);
    return function () {
      return document.removeEventListener('keydown', handleKeyboardEvent);
    };
  }, [showDescription]);
  return /*#__PURE__*/_react.default.createElement(TipContainer, {
    "aria-label": "Tool tip",
    role: "dialog"
  }, /*#__PURE__*/_react.default.createElement(TipButton, {
    id: "tipTitle",
    ref: dialogOpenTrigger,
    role: "button",
    tabIndex: 0,
    onClick: toggleShowDescription
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "".concat(buttonText, " Icon"),
    "aria-hidden": "true",
    src: icon.url
  }), /*#__PURE__*/_react.default.createElement("div", {
    "aria-hidden": "true"
  }, buttonText)), /*#__PURE__*/_react.default.createElement(TipDescription, {
    ref: dialogDescriptionTrigger,
    tabIndex: 0,
    visibility: showDescription
  }, description, /*#__PURE__*/_react.default.createElement(CloseButtonContainer, {
    "aria-label": "Close dialog",
    id: "tip-close",
    ref: dialogCloseTrigger,
    role: "button",
    tabIndex: 0,
    onClick: toggleShowDescription
  }, "X")));
};

Tip.defaultProps = {};
var _default = Tip;
exports.default = _default;